// Footer.js
import React from 'react';

const Footer = () => (
  <footer className="site-footer">
    <p>© NK Little League {new Date().getFullYear()} </p>
  </footer>
);

export default Footer;
